module.exports = {
  "info": "INFO",
  "menu": "MENU",
  "delivery": "LIVRAISON",
  "hours": "HEURES",
  "dinner": "DÎNER - du lundi au dimanche 17 heures - fermeture",
  "reservations": "RÉSERVATIONS",
  "information": "INFORMATION",
  "phone": "(514) 933-9433",
  "meat": "VIANDE",
  "wild-bass-crudo": "CRUDO DE BAR SAUVAGE ",
  "wild-bass-crudo-desc": "avocat, micro coriandre",
  "dinner_menu": "MENU DE DÎNER",
  "raw-bar": "BAR CRU",
  "mixed-oysters": "HUÎTRES ASSORTIES",
  "six": "six",
  "twelve": "douze",
  "shrimp-cocktail": "COCKTAIL DE CREVETTES",
  "six-shrimp": "six creuvette",
  "snow-crab-cocktail": "CRABE DES NEIGES",
  "half": "demi",
  "full": "entier",
  "lobster-cocktail": "COCKTAIL DE HOMARD",
  "seafood": "FRUIT DE MER",
  "seafood-platter": "PLATEAU DE FRUITS DE MERPLATTER",
  "small": "petit",
  "seafood-platter-small-desc": "neuf huîtres, quatre crevettes, oysters, four shrimp,",
  "seafood-platter-small-desc-two": "un demi crabe des neiges, un demi homard",
  "large": "large",
  "seafood-platter-large-desc": "dix-huit huîtres, six crevettes,",
  "seafood-platter-large-desc-two": "un crabe des neiges entier, un homard entier",
  "bloody-caesar": "BLOODY CAESAR AUX FRUITS DE MER",
  "bloody-caesar-desc": "bloody caesar classique avec une huître,",
  "bloody-caesar-desc-two": "une crevette, et une patte de crabe",
  "starters": "ENTRÉES",
  "kale-salad": "SALADE DE CHOU FRISÉ ",
  "kale-salad-desc": " maïs sucré, parmesan",
  "cajun-shrimp-salad": "SALADE DE CREVETTES CAJUN ",
  "cajun-shrimp-salad-desc": " avocat",
  "tuna-sashimi": "SASHIMI DE THON ",
  "tuna-sashimi-desc": " sauce ponzu, chimichurri",
  "wedge-salad": "QUARTIER DE LAITUE ",
  "wedge-salad-desc": " fromage bleu, bacon fumé, cornichons",
  "salmon-tartare": "TARTARE DE SAUMON ",
  "salmon-tartare-desc": " style asiatique, laitue, nouilles de riz croustillantes",
  "beet-salad": "SALADE DE BETTERAVES ",
  "beet-salad-desc": " mozzarella, pommes, crostinis, pois chiches assaisonnés",
  "tuna-tartare": "TARTARE DE THON ",
  "tuna-tartare-desc": " avocats, soya",
  "caesar-salad": "SALADE CÉSAR ",
  "caesar-salad-desc": " laitue romaine, croustilles cajuns, oignons rouges marinés, cornichons",
  "black-angus-beef": "TARTARE DE BOEUF ",
  "black-angus-beef-desc": " graines de dijon, cornichons, panure, oeuf mi-cuit",
  "fish-tacos": "TACOS DE POISSON ",
  "fish-tacos-desc": " tomatillo, purée de mangue, chou rouge",
  "mykonos-greek-salad": "SALADE GRECQUE MYKONOS ",
  "mykonos-greek-salad-desc": " tomates anciennes, feta de chèvre",
  "roasted-cauliflower": "CHOU-FLEUR RÔTI ",
  "roasted-cauliflower-desc": " tomates cerises, parmesan",
  "steamed-clams": "PALOURDES À LA VAPEUR ",
  "steamed-clams-desc": " ail, vin blanc",
  "chopped-salad": "SALADE FATTOUCHE ",
  "chopped-salad-desc": " radis, concombre, tomates cerises",
  "crispy-calamari": "CALAMARS CROUSTILLANTS ",
  "crispy-calamari-desc": " aïoli de vinaigre de malt",
  "pasta": "PÂTES",
  "lobster-cavatelli": "CAVATELLI AU HOMARD ",
  "lobster-cavatelli-desc": " bisque de homard, mascarpone",
  "chicken-parmesan": "ESCALOPE DE POULET AU PARMESAN ",
  "chicken-parmesan-desc": " mozzarella di bufala",
  "penne-rose": "PENNE ROSÉ ",
  "penne-rose-desc": " puree de tomates, mozzarella, parmesan",
  "mixed-grilled-seafood": "GRILLADE DE FRUITS DE MER ",
  "mixed-grilled-seafood-desc": " pieuvre, calmars, crevettes",
  "shrimp-brochette": "BROCHETTE DE CREVETTES ",
  "shrimp-brochette-desc": " glacé de citron et chili, tortillas",
  "grilled-octopus": "PIEUVRE GRILLÉE ",
  "grilled-octopus-desc": " salade grecque",
  "salmon-filet": "FILET DE SAUMON SAISI ",
  "salmon-filet-desc": " concombre, yogourt grec, aneth",
  "lobster-salad": "SALADE DE HOMARD ",
  "lobster-salad-desc": " céleri, rouleau de printemps",
  "whole-grilled-lobster": "HOMARD GRILLÉE ",
  "whole-grilled-lobster-desc": " salade verte et frites",
  "branzino-filet": "FILET DE LOUP DE MER ",
  "branzino-filet-desc": " sur salade fattouche",
  "lobster-rolls": "GUÉDILLES DE HOMARD ",
  "lobster-rolls-desc": " frites ou salade verte",
  "taco-board": "PLATEAU DE TACOS ",
  "taco-board-desc": " boeuf, poulet, crevettes, guacamole",
  "veal-milanese": "VEAU À LA MILANAISE ",
  "veal-milanese-desc": " réduction balsamique, salade d’avocat",
  "portuguese-chicken": "POULET PORTUGAIS ",
  "portuguese-chicken-desc": " salade de chou",
  "junior-burgers": "DEUX CHEESEBURGERS JUNIORS ",
  "junior-burgers-desc": " entrecôte haché, frites",
  "baby-back-ribs": "CÔTES LEVÉES ",
  "baby-back-ribs-desc": " frites maison",
  "surf-turf": "SURF & TURF",
  "surf-turf-desc": " une guédille de homard, côtes levées, frites",
  "steaks": "STEAKS",
  "with-fries": "servi avec frites ou salade",
  "filet-mignon": "FILET MIGNON",
  "kansas-cut": "COUPE KANSAS",
  "tbone": "T-BONE",
  "ribsteak": "ENTRECOTE",
  "steaks-for-two": "coupe pour deux",
  "porterhouse": "PORTERHOUSE",
  "cote-de-boeuf": "CÔTE DE BOEUF",
  "chateaubriand": "CHATEAUBRIAND",
  "pepper-sauce": "SAUCE POIVRE",
  "sides": "ACCOMPAGNEMENTS",
  "homecut-fries": "Frites Maison",
  "sweet-potato-fries": "Frites de Patates Douces",
  "cheesy-mash": "Purée de PDT au Fromage",
  "small-greek-salad": "Petite salade grecque",
  "grilled-vegetables": "Légumes Grillés",
  "onion-rings": "Rondelles d’Oignon",
  "side-caesar-salad": "Petite salade César",
  "mixed-green-salad": "Salade Verte",
  "avocado-salad": "Salade d’Avocat",
  "copyright": "Droit d'auteur © 2017 Brasserie Lucille. Tous droits réservés.",
  "description": "Notre rouleau de homard célèbre et délicieux fruits de mer. Steaks âgés à sec et grillées à la perfection. Livrer à une soirée au Brasserie Lucille!",

  "beef-carpaccio": "BEEF CARPACCIO",
  "beef-carpaccio-desc": " crôute de porcini, mâche, rouille au homard, réduction de balsamique",
  "branzino-crudo": "CRUDO DE LOUP DE MER",
  "branzino-crudo-desc": " huile d'olive, sel de mer, citron",
  "miami-short-rib": "CÔTELETTES DE BOEUF MIAMI",
  "miami-short-rib-desc": " bouillon dashi, tofu, chou frisé",
  "singapore-slaw-salad": "SALADE DE SINGAPOUR À 19 INGRÉDIENTS",
  "singapore-slaw-salad-desc": " avec sashimis de thon rouge et de loup de mer",
  "roasted-bass-filet": "FILET DE BAR RÔTI",
  "roasted-bass-filet-desc": " salade d'asperges jumbos et de basilique",
  "bookenda-url": "https://www.bookenda.com/brasserie-lucilles?PartnerNumber=1&IdClientApplication=2427&IdServiceOccurence=0&Language=French#Reservation",
  "bookenda-image": "http://www.bookenda.com/Images/badge-booknow_book_FR.png",
}



// WEBPACK FOOTER //
// ../public/messages/fr.js